export default "__VITE_ASSET__SBOA1hQk__"